import type { ButtonHTMLAttributes, Ref } from "react";

import { tile } from "~/components/OptionTile.css";

export type OptionTileVariant = "solid" | "dashed";

export interface OptionTileProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "type" | "aria-pressed"> {
  /** Is this the option chosen? */
  pressed: boolean;
  /** "dashed" sets apart the option that declines the others. Defaults to
   *  "solid". */
  variant?: OptionTileVariant;
  ref?: Ref<HTMLButtonElement>;
}

/**
 * One option of a set the human picks one of: a full-width toggle button whose
 * content is the caller's, so an option can carry lines of detail under its
 * name. It never submits a form.
 */
export function OptionTile({ pressed, variant = "solid", className, ref, ...rest }: OptionTileProps) {
  const merged = [tile[variant], className]
    .filter((c) => c !== undefined && c.length > 0)
    .join(" ");
  return <button ref={ref} type="button" aria-pressed={pressed} className={merged} {...rest} />;
}
